export enum BulkGridSelectionModeEnum {
  All = "All",
  Page = "Page",
  Rows = "Rows",
}
